import React from 'react';
import PropTypes from 'prop-types';
import AppOpenButton from "./AppOpenButton";
import './AppMobileBanner.css';
import fruitsfamilyLogo from "../appTopBanner/assets/rounded_logo.svg";
import iconStar from "../appTopBanner/assets/ic_black_star.svg";

export default function AppMobileBanner({hostname, userAgent}) {
    return (
        <div className="Mobile-banner-container Navigation-navbar navbar navbar-expand-md">
            <div className='container'>
                <div className='Mobile-banner'>
                    <img className="Logo" alt="FruitsFamily™" src={fruitsfamilyLogo} />
                    <div className='Content'>
                        <div className='Title'>후루츠 - 300만 패션 러버와 함께 디깅해요!</div>
                        <div className='Description' aria-label="평점 4.9점">
                            <div aria-hidden="true">
                                <img src={iconStar} alt="" />
                                <img src={iconStar} alt="" />
                                <img src={iconStar} alt="" />
                                <img src={iconStar} alt="" />
                                <img src={iconStar} alt="" />
                            </div>
                            <div className='Text'>(4.9)</div>
                        </div>
                    </div>
                </div>
                <div className="AppOpenButton-wrapper">
                    <AppOpenButton hostname={hostname} userAgent={userAgent}/>
                </div>
            </div>
        </div>
    );
}

AppMobileBanner.propTypes = {
    hostname: PropTypes.string.isRequired,
    userAgent: PropTypes.string.isRequired,
};
